// extracted by mini-css-extract-plugin
export default {"component":"Breadcrumbs__component--lc-ULwGP","item":"Breadcrumbs__item--lc-uxy4r","active":"Breadcrumbs__active--lc-tpaaT Breadcrumbs__component--lc-ULwGP"};